module.exports = __webpack_public_path__ + "static/media/poc_admin_active.7cba8a34.svg";